import { action } from '@ember/object';
import type Owner from '@ember/owner';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

import type { Service } from 'webapp-types';
import { isAlive } from 'webapp/utils/common';

import FormInputComponent from 'webapp/components/form/input';
import SubmitButtonComponent from 'webapp/components/submit-button';

interface Args {
	modelName: string;
	onPassword: (pw: string) => Promise<{ password?: string }>;
}

export default class DatawallWallPasswordComponent extends Component<Args> {
	@service('account') declare accountService: Service.Account;
	@service('request') declare requestService: Service.Request;

	originalMessage;

	@tracked message;
	@tracked isError = false;
	@tracked submitInProgress = false;
	@tracked password = '';

	constructor(owner: Owner, args: Args) {
		super(owner, args);

		this.originalMessage = 'This is a password protected ' + (this.args.modelName || '');
		this.message = this.originalMessage;
	}

	get hideBranding() {
		return this.accountService.removeBrandingOnFeatures;
	}

	@action
	verify() {
		if (this.password) {
			this.isError = false;
			this.message = this.originalMessage;
			this.submitInProgress = true;

			this.args
				.onPassword(this.password)
				.then((data) => {
					if (data.password === 'failed') {
						if (isAlive(this)) {
							this.isError = true;
							this.message = 'Wrong password. Please try again.';
							this.submitInProgress = false;
						}
					}
				})
				.catch(this.requestService.handleGenericThrownError.bind(this.requestService));
		} else {
			this.isError = true;
			this.message = 'Password is required';
			this.submitInProgress = false;
		}
	}
	<template>
		<div id="passwordWrapper">
			<div class="form {{if this.isError 'error'}}">
				<p>
					{{this.message}}
				</p>
				<FormInputComponent
					@type="password"
					name="wallPassword"
					@value={{this.password}}
					@hideFloatLabel={{true}}
					@insertNewline={{this.verify}}
					@autofocus={{true}}
					placeholder="Password"
					disabled={{this.submitInProgress}}
				/>
				<div class="controls2 controls2--center">
					<SubmitButtonComponent
						@text="OK"
						@noDelay={{true}}
						@extraClass="save"
						@ripplerEffect={{false}}
						@onTrigger={{this.verify}}
						@submitInProgress={{this.submitInProgress}}
					/>
				</div>
			</div>
			{{#unless this.hideBranding}}
				<a href="https://databox.com" target="_blank" class="powered">
					Powered by
					<img
						src="https://cdn1.databox.com/images/logo/databox-allwhite.svg"
						height="20"
						alt="Databox"
					/>
				</a>
			{{/unless}}
		</div>
	</template>
}
